import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Modal from '../../components/modal';
import GenerateModalHeader from './Header';

// Views
import VideoView from './View/Video';
import Podcast from './View/Podcast';

// Styles
import styles from './style.module.scss';

// Context
import { GenerateModalProvider } from './context';

// Icons

// Types
import { GenerateType } from '../types';

interface GenerateModalProps {
  open: boolean;
  onClose: () => void;
  type: GenerateType | null;
}

const GenerateModal: React.FC<GenerateModalProps> = ({ open, onClose, type }) => {
  // Hooks
  const { t } = useTranslation();
  // States

  // Methods
  const handleCloseMainModal = useCallback(() => {
    onClose();
  }, [onClose]);

  // Memoized Values
  const contextValue = useMemo(() => ({
    type,
    onCloseMainModal: handleCloseMainModal,
  }), [type, handleCloseMainModal]);

  // Handlers

  if (!type) return null;
  return (
    <GenerateModalProvider value={contextValue}>
      <Modal
        open={open}
        onClose={onClose}
        classes={{ content: styles.modal }}
        title={<GenerateModalHeader onClose={onClose} />}
      >
        {type === 'video' && <VideoView />}
        {type === 'podcast' && <Podcast />}
      </Modal>
    </GenerateModalProvider>
  );
};

export default GenerateModal;
